import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PasswordResetState } from '€slices/password-reset/password-reset-types';
import { actions as authActions } from '€slices/auth';
import { RequestState } from '~/src/types/RequestState';

const initialState: PasswordResetState = {
    requestingEmail: false,
    requestEmailSuccess: false,

    resetting: false,
    resetFailed: false,
    resetSuccess: false,
    resetError: null,

    resetTokenValidateState: RequestState.Idle,
    validResetToken: null,
};

const slice = createSlice({
    name: 'passwordReset',
    initialState: initialState as PasswordResetState,
    reducers: {
        reset: () => initialState,
        requestEmail: state => ({
            ...state,
            requestingEmail: true,
            requestEmailSuccess: false,
        }),
        receiveEmailSuccess: (state, action: PayloadAction<string>) => ({
            ...state,
            requestingEmail: false,
            requestEmailSuccess: true,
            requestEmailSuccessEmail: action.payload,
        }),
        receiveEmailError: state => ({
            ...state,
            requestingEmail: false,
            requestEmailSuccess: false,
        }),
        requestValidateToken: state => ({
            ...state,
            resetTokenValidateState: RequestState.Loading,
        }),
        successValidateToken: (state, action: PayloadAction<string>) => ({
            ...state,
            resetTokenValidateState: RequestState.Idle,
            validResetToken: action.payload,
        }),
        errorValidateToken: state => ({
            ...state,
            resetTokenValidateState: RequestState.Error,
        }),
        requestReset: state => ({
            ...state,
            resetting: true,
            resetFailed: false,
            resetSuccess: false,
            resetError: null,
        }),
        receiveResetSuccess: state => ({
            ...state,
            resetting: false,
            resetFailed: false,
            resetSuccess: true,
            resetError: null,
        }),
        receiveResetError: (state, action: PayloadAction<string>) => ({
            ...state,
            resetting: false,
            resetFailed: true,
            resetSuccess: false,
            resetError: action.payload,
        }),
    },
    extraReducers: {
        [authActions.requestLogin.type]: state => ({
            ...state,
            // this is just used to unset the success message once a login attempt is made.
            resetSuccess: false,
        }),
        [authActions.receiveLoginSuccess.type]: () => initialState,
    },
});

export default slice;
export const { actions, reducer } = slice;
